import axios from 'axios';
import React, { useEffect, useState } from 'react';
import localStorage from '../../../utils/localStorage';

const TextComponent = ({ text, column }) => {
  const [optionList, setOptionList] = useState([]);

  useEffect(() => {
    const fetchOptionList = async () => {
      let siteId = localStorage.get('currentSite');
      const accessToken = localStorage.get('accessToken');
      let objectHeader = {};

      if (column && column.table && column.table.url && column.table.method) {
        objectHeader = {
          method: column.table.method,
          url: `${column.table.url}?SiteId=${siteId}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: {
            ...column.table.payload
          }
        };
      }

      try {
        const response = await axios(objectHeader);
        if (Array.isArray(response.data)) {
          setOptionList(response.data);
        }
      } catch (error) {
        console.error('Error fetching option list:', error);
      }
    };

    fetchOptionList();
  }, [column]); // Dependency array includes column to refetch when it changes

  // Filter the option list based on the text prop
  const filter = optionList.filter((option) => option.Value === text);
  
  return <div>{filter.length > 0 && filter[0].Key ? filter[0].Key : text}</div>;
};

export default TextComponent;